<template>
    <v-container class="pa-0 ma-0 page-container bg-bug h-100"> 
        <Topnavbar title="" @back="handleRouteBack"/>
        <v-container class="mb80">
            <div class="bg-white pa-4" v-if="this.surveys && this.surveys.length">
                <!-- <div v-if="this.step <= this.questions.length" class="mb-10 mt-5">
                    <v-progress-linear  
                        v-model="progressValue"
                        :active="show"
                        height="6"
                        :indeterminate="query"
                        :query="true">
                    </v-progress-linear>
                </div> -->
                <!-- <div v-for="(survey, index) in surveys" :key="index"> -->
                <div div>
                    <!-- <div v-if="activeSurvey.survey.is_multi"> -->
                    <div>
                        <h4 class="mb-6 color-primary text-capitalize">{{activeSurvey.survey.name}}</h4>
                        <v-form ref="surveyForm">
                            <div v-for="(question,i) in activeSurvey.survey.questions" :key="i">
                                <div class="text-capitalize f8-bold" :id="'q'+question.id" v-html="question.question"></div>
                                <div>
                                    <div v-if="question.question_type =='checkbox_with_lookup'">
                                        <div>
                                            <v-checkbox v-for="(item,n) in question.lookups" :key="n"
                                            class="ma-0 pa-0"
                                            v-model="answers[question.id]"
                                            :label="item.text"
                                            multiple
                                            :value="item.id"
                                            ></v-checkbox>
                                        </div>
                                    </div>
                                    <div v-if="question.question_type =='checkbox'">
                                        <div>
                                            <v-checkbox v-for="(item,n) in question.options" :key="n"
                                            class="ma-0 pa-0"
                                            v-model="answers[question.id]"
                                            :label="item.value"
                                        
                                            multiple
                                            :value="item.value"
                                            ></v-checkbox>
                                        </div>
                                    </div>
                                    <div v-if="question.question_type =='text'">
                                        <v-text-field class="ma-0 pa-0"  v-model="answers[question.id]"></v-text-field>
                                    </div>
                                    <div v-if="question.question_type =='radio'">
                                        <v-radio-group v-model="answers[question.id]">
                                            <v-radio
                                                v-for="(item,n) in question.options"
                                                :key="n"
                                            
                                                :label="item.value"
                                                :value="item.value"
                                            ></v-radio>
                                        </v-radio-group>
                                    </div>
                                    <div v-if="question.question_type =='radio_with_text'" class="d-flex align-center">
                                        <v-text-field class="mt-3 mr-4" label="Value" v-model="empty[question.id]" @blur="handleBlur($event,question.id)"></v-text-field>
                                        <InputAutocomplete @selected="selectedAnswers" label="Select" 
                                            :itemSelected="question.options[0]" 
                                            :questionId="question.id"
                                            :items="question.options"/>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                        <div>
                            <div class="d-flex" :class="activeSurveyIndex==0 ? 'justify-space-around' : 'justify-space-between'">
                                <v-btn v-if="activeSurveyIndex>0" @click="handleBack">Back</v-btn>
                                <v-btn color="primary" v-if="activeSurveyIndex < (surveys.length - 1)" @click="handleNextSurvey">Next</v-btn>
                                <v-btn color="primary" v-else @click="handleSubmitSurvey">Submit</v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="not-available">
                    <h3 class="ma-0">{{message}}</h3>
                </div>
            </div>
        </v-container>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { ApiService } from '@/core/services/api.service'
import InputAutocomplete from '@/components/form-element/InputAutocompleteValue'
import Topnavbar from '@/components/layout/TopnavbarBackCustom'
export default {
    data() {
        return {
            title:'',
            step:1,
            size:20,
            value:3.5,
            answer:'',
            message:'Loading...',
            progressValue: 10,
            query: false,
            show: true,
            interval: 0,
            images:[],
            modalDelete:false,
            appointmentId:null,
            activeQuestionIndex:0,
            activeQuestion:{},
            questions:[],
            questionaaa:[],
            answers:{},
            radio_text:'',
            questionLength:0,
            surveys:[],
            activeSurvey:[],
            activeSurveyIndex:0,
            empty:{},
        }
    },
    components: {
        Topnavbar,
        // ButtonCamera,
        InputAutocomplete
    },
    mounted() {
        this.appointmentId = this.$router.currentRoute.params.id;
        this.fetchQuestions();
    },
    watch:{
        answers(val) {
            console.log({val});
        }
    },
    methods: {
         fetchQuestions() {
            this.loaderShow();
            ApiService.post('/appointment-questions')
            .then((resp) => {   
                this.loaderHide();
                this.surveys = resp.data.surveys;
                this.activeSurvey= this.surveys[this.activeSurveyIndex];
            })
            .catch((error) => {
                this.loaderHide();
                console.log(error);
            })
        },
         handleNextSurvey(){
            let form = this.$refs.surveyForm.validate();
            // console.log(this.surveys[this.activeSurveyIndex].survey.questions);
            console.log(form);
            let totalquestion = 0;
            let answerIds = [];
            for(const id in this.answers){
                answerIds.push(parseInt(id))
            }
            // let answers = this.answers.filter((x, index)=> index);
            console.log({answerIds});
            console.log("survey inddex: ",this.activeSurveyIndex);
            if(this.activeSurveyIndex < this.surveys.length){
                this.surveys.forEach((element, index) => {
                    if(index<= this.activeSurveyIndex){
                        totalquestion+= element.survey.questions.length;
                        // element.survey.questions.forEach((question) => {
                        //     console.log("question id",question.id);
                        //     if(answerIds.includes(question.id)){
                        //         console.log("cha: ",question.id);
                        //         document.getElementById('q'+question.id).style.color="black";
                        //     }else{
                        //         console.log("chiana : ",question.id);
                        //         document.getElementById('q'+question.id).style.color="red";
                        //     }
                        // });
                    }
                });
                this.surveys[this.activeSurveyIndex].survey.questions.forEach((question) => {
                    if(answerIds.includes(question.id)){
                        document.getElementById('q'+question.id).style.color="black";
                    }else{
                        document.getElementById('q'+question.id).style.color="red";
                    }
                });
                if( Object.keys(this.answers).length < totalquestion){
                    this.messageError('Please fill up all the fields');
                    return;
                }else{
                    this.activeSurveyIndex+=1;
                    this.activeSurvey= this.surveys[this.activeSurveyIndex];
                }
            }else{
                console.log("no next");
            }
            //   scrollToTop() {
            window.scrollTo(0,0);
        //    }
        },
        handleSubmitSurvey(){
            let answerIds = [];
            for(const id in this.answers){
                answerIds.push(parseInt(id))
            }
            let count = 0;
            
            this.surveys.forEach((item)=> {
                count+= item.survey.questions.length;
            });
            if(!Object.keys(this.answers).length){
                this.messageError('Fields are empty');
                return;
            }else  if(Object.keys(this.answers).length !== count){
                this.surveys[this.activeSurveyIndex].survey.questions.forEach((question) => {
                    if(answerIds.includes(question.id)){
                        document.getElementById('q'+question.id).style.color="black";
                    }else{
                        document.getElementById('q'+question.id).style.color="red";
                    }
                });
                this.messageError('Please fill up all the fields');
                return;
            }

            // console.log(Object.keys(this.answers).length);
            this.loaderShow();
            ApiService.post('/sp-service-complete',{
                answers: JSON.stringify(this.answers),
                appointmentId: this.appointmentId,
                // survayId: this.questions[0].survey_id,
            })
            .then(() => {
                this.loaderHide();
                this.messageSuccess('Submitted successfully');
                this.$router.push('/technical-service/'+this.appointmentId)
            })
            .catch((error) => {
                this.loaderHide();
                this.messageError(error.message);
            })
        },
       
       
        handleRouteBack(){
            this.$router.back();
        },
        handleBlur(e,id){

            this.answers[id] = this.answers[id] ? { 'value': e.target.value,...this.answers[id]}: { value: e.target.value};

        },
        selectedAnswers(data) {
            if(data.question_id){
                 this.answers[data.question_id] = this.answers[data.question_id] ? { 'type': data.selected_data,...this.answers[data.question_id]}: { type: data.selected_data};
            }
            // console.log(this.answers)
            // this.answers.push(data.selected_data);  
            // if(this.activeQuestion.question_type == 'radio_with_text'){
            //     // this.answers[this.activeQuestionIndex] = this.radio_text+ " "+data.selected_data;
            //     this.answer =  this.radio_text+ " "+data.selected_data;
            // }else{
            //     // this.answers[this.activeQuestionIndex] = data.selected_data;
            //     this.answer =  this.radio_text+ " "+data.selected_data;
            // }
            // console.log(this.answers);
        },
        handlePhoto(index){
            this.images = this.images.filter((x,y) =>{
                console.log(x);
                return y!=index;
            });

        },
        captureImage(event) {
            event.target.files.forEach(element => {
                this.images.push(URL.createObjectURL(element));
            });
        },
        handleNext() {
            if(this.answer == "" && this.activeQuestion.question_type == 'text'){
                this.messageError('Please, answer all questions');
                return;
            }
            
            if(this.step < this.questionLength){
                if(this.activeQuestion.question_type != 'radio') {    
                    this.answers[this.activeQuestionIndex] = this.answer;
                    this.radio_text = "";
                }else if(this.activeQuestion.question_type == 'radio_with_text'){
                    this.answers[this.activeQuestionIndex] = this.radio_text+ " "+this.answer;
                    this.radio_text = "";
                }else{
                    this.answers[this.activeQuestionIndex] = this.answer;
                    this.radio_text = "";
                }
                this.answer = "";
                this.step +=1;
                this.activeQuestionIndex += 1;
                this.activeQuestion = this.questions[this.activeQuestionIndex];
            
                this.progressValue = (this.step/12)*100;
            }else{
                this.step+=1;
            }
        },
        handleBack() {
            if(this.activeSurveyIndex>0){
                this.activeSurveyIndex -=1;
                this.activeSurvey = this.surveys[this.activeSurveyIndex];
            }
            window.scrollTo(0,0);
        },
       
    },
    computed: {
        ...mapGetters(['currentUser'])
    }

}
</script>
<style lang="scss" scoped>
.not-available{
    // background:#fff;
    height:200px;
    display:flex;
    justify-content: space-around;
    align-items: center;
    // color:#dadada;
}
    // $color-primary: #01a6bc;
    // $color-secondary: #01a6bc;
    .page-container{
        .item-wrapper{
            background:#f5f5f5;
            padding: 10px;
            text-align: center;
            min-height: 100px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-between;
            border-radius: 0;
            i{
                font-size: 3.1rem;
                // color: #01a6bc;
            }
            p{
                margin: 0;
                padding: 0;
                text-align: center;
                font-weight: 500;
                color: #5a5a5a;
                text-transform: capitalize;
                font-size: 0.8rem;
                letter-spacing: 0.7px;
            }
        }
    }
    .image-wrapper{
        display:flex;
        flex-wrap: wrap;
        justify-content: flex-start;

    }
    .ratings-star{
        list-style:none;
        padding:0;
        li{
            display:flex;
            list-style:none;
            align-items:center;
            justify-content: space-between;
            span{
                font-size:0.8rem;
                font-weight: 600;
            }
        }
    }
    .question-style{
        font-weight: 600;
        color: #8bc34a;
        text-transform: capitalize;
        font-size: 20px;
        text-align: center;
    }
</style>